import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  constructor(
    public db: AngularFireDatabase,
  ) { }

  listPending() {
    const items = this.db.list(`orders/requests`).valueChanges();
    return items;
  }

  approve(id, orderData) {
    return this.db.object(`orders/requests/${id}`).remove().then(() => {
      const orderIdGenerate = this.db.createPushId();
      orderData.orderId = orderIdGenerate;
      orderData.type = 'accept';
      this.db.object(`orders/accepts/${orderIdGenerate}`).set(orderData);
    });
  }

  remove(id) {
    return this.db.object(`orders/requests/${id}`).remove();
  }
}
